import { Button, Stack } from '@mui/material';
import UtilityDrawerBody from 'components/drawers/utility-drawer/utility-drawer-body/utility-drawer-body.component';
import UtilityDrawerFooter from 'components/drawers/utility-drawer/utility-drawer-footer/utility-drawer-footer.component';
import UtilityDrawer from 'components/drawers/utility-drawer/utility-drawer.component';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParamsContext } from '../search.hooks';

const SearchFilterDrawer = ({ children, open, close, drawerData }) => {
  const { t } = useTranslation();
  const { searchFilters } = useSearchParamsContext();
  const focused = useRef<string>();

  useEffect(() => {
    if (
      open &&
      !!drawerData &&
      focused.current !== drawerData &&
      !!searchFilters?.[drawerData]?.filter?.focus
    ) {
      searchFilters[drawerData].filter.focus();
      focused.current = drawerData;
    } else if (!open) {
      focused.current = null;
    }
  }, [drawerData, open, searchFilters]);

  return (
    <UtilityDrawer
      open={open}
      onClose={close}
      data-testid="SearchFilterDrawer"
      title={<strong>{t('drawer.searchFilterDrawer.title')}</strong>}
    >
      <UtilityDrawerBody>
        <Stack data-testid="SearchFilterDrawer.FilterContainer">
          {children}
        </Stack>
      </UtilityDrawerBody>
      <UtilityDrawerFooter>
        <Button
          fullWidth
          color="primary"
          onClick={close}
          data-testid="SearchFilterDrawer.ApplyButton"
        >
          Apply
        </Button>
      </UtilityDrawerFooter>
    </UtilityDrawer>
  );
};

export default SearchFilterDrawer;
